import type { UserSession } from 'types';

export type ApplicantInfoField = 'phoneNumber' | 'school' | 'grade' | 'ethnicity';

function filled(value: unknown): boolean {
  return typeof value === 'string' && value.trim().length > 0;
}

export function applicantSchoolName(user: UserSession): string {
  return (user.schoolName || user.academics?.school?.schoolName || '').trim();
}

/** Fields the SCLA application needs before a student can continue. */
export function missingApplicantInfoFields(user: UserSession): ApplicantInfoField[] {
  const missing: ApplicantInfoField[] = [];
  if (!filled(user.phoneNumber)) missing.push('phoneNumber');
  if (!filled(applicantSchoolName(user))) missing.push('school');
  if (!filled(user.gradeLevel)) missing.push('grade');
  if (!filled(user.ethnicity)) missing.push('ethnicity');
  return missing;
}

export function needsApplicantInfo(user: UserSession): boolean {
  return missingApplicantInfoFields(user).length > 0;
}
